import Constant from '@/common/constant/Constant';
import localStorageUtil from '@/common/utils/localStorageUtil';
import Utils from '@/common/utils/utils';
import LoadingPanel from '@/component/common/LoadingPanel';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { projectListInCorporationAtom } from '@/state/atom/projectAtom';
import { userAtom } from '@/state/atom/userAtom';
import { isManagerByProjectInuseSelector } from '@/state/selector/projectSelector';
import { AppBar, Tab, Tabs } from '@material-ui/core';
import { Auth } from 'aws-amplify';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import CustomerListInCorporation from './CustomerListInCorporation';
import './ProjectUserManagement.css';
import CancelTabsDialog from '../system/dialog/CancelTabsDialog';
import { closeTabId, multiPanelAtom } from '@/state/atom/panelAtom';
import { closePanelTabSelector } from '@/state/selector/panelSelector';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function CorporationCustomerManagement(props) {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setIsLoading] = useState(false);

    // common userDetail state
    const userDetail = useRecoilValue(userAtom);

    // common corporationDetail state
    const corporationDetail = useRecoilValue(corporationAtom);

    // common projectListInCorporation state
    const listProjectInCorp = useRecoilValue(projectListInCorporationAtom);

    // common projectInuse state
    const [projectDetail, setProjectDetail] = useState({});

    // check is admin
    const isAdmin = Utils.isAdminUser(userDetail);

    // check is pm
    let currentIsProjectManager = useRecoilValue(isManagerByProjectInuseSelector);
    const [isProjectManager, setIsProjectManager] = useState(currentIsProjectManager);

    const [tabSelected, setTabSelected] = useState(Constant.CORPORATION_CUSTOMER_TAB_MANAGEMENT.TAB_CUSTOMER_LIST_CORPORATION);

    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const [closeTabIdState, setCloseTabIdState] = useRecoilState(closeTabId);
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const [isConfirmCancelTabs, setIsConfirmCancelTabs] = useState(false);
    const [isChangeData, setIsChangeData] = useState(false);

    const [isDisplayProjectUserTab, setIsDisplayProjectUserTab] = useState(false);
    const [adminMode, setAdminMode] = useState(Constant.ADMIN_MODE.OFF);

    let argsAll = {
        ...props,
        API: props?.API,
        corporationDetail,
        corporationId: corporationDetail.id,
        corporationSubdomain: localStorageUtil.getCorporationDomain(),
        projectId: localStorageUtil.getSelectedProjectId(),
        username: Auth.user.username,
        userDetail,
        setIsLoading,
        enqueueSnackbar,
        projectDetail,
        tabSelected,
        setTabSelected,
        isProjectManager,
        setIsProjectManager,
        isAdmin,
        panelList,
        setPanelList,
        closePanelTab,
        isConfirmCancelTabs,
        setIsConfirmCancelTabs,
        isDisplayProjectUserTab,
        setIsDisplayProjectUserTab,
        setAdminMode,
        adminMode,
        isLoading
    };

    useEffect(() => {
        if(!Utils.isEmptyObject(listProjectInCorp)) {
            let guestCustomerProjectIndex = listProjectInCorp.findIndex(p => p.type === Constant.PROJECT_TYPE.CUSTOMER);
            if(guestCustomerProjectIndex !== -1) {
                let guestCustomerProject = listProjectInCorp[guestCustomerProjectIndex];
                setProjectDetail(guestCustomerProject);
            }
        }
    }, [listProjectInCorp]);

    useEffect(() => {
        let userSettingValue = userDetail?.userSetting;
        if (!Utils.isEmptyObject(userSettingValue)) {
            userSettingValue = Utils.convertJSONDataToObject(userSettingValue);
            setAdminMode(userSettingValue.adminMode);
        } else {
            setAdminMode(Constant.ADMIN_MODE.OFF);
        }
    }, [userDetail]);

    useEffect(() => {
        if (props.tabId === closeTabIdState) {
            if (isChangeData) {
                setIsConfirmCancelTabs(true);
            } else {
                let currentPanelInfo = Utils.getPanelInfo(props.panelId, panelList);
                if (!currentPanelInfo || Utils.isEmptyObject(currentPanelInfo)) return;
                closePanelTab({
                    event: null,
                    panelType: currentPanelInfo.type,
                    panelId: props.panelId,
                    tabId: props.tabId
                });
            }
            setCloseTabIdState(0);
        }
    }, [closeTabIdState]);

    useEffect(() => {
        // set is project manager when change
        setIsProjectManager(currentIsProjectManager);
    }, [currentIsProjectManager]);

    const onChangeTab = (event, newValue) => {
        setTabSelected(newValue);
    };

    const isChangeDataPj = child => {
        setIsChangeData(child);
    };

    const renderContentTab = tabSelect => {
        switch (tabSelect) {
            case Constant.CORPORATION_CUSTOMER_TAB_MANAGEMENT.TAB_CUSTOMER_LIST_CORPORATION: {
                return <CustomerListInCorporation {...argsAll} parentCallBack={isChangeDataPj} />;
            }
            default: {
                return <></>;
            }
        }
    };

    return (
        <div className="projectUser">
            <LoadingPanel isLoading={isLoading} />

            <div className="tabList">
                <div className="navTabs">
                    <AppBar className="navTabs-box" position="static">
                        <Tabs
                            className="navTabs-rot"
                            value={tabSelected}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="scrollable"
                            scrollButtons="auto"
                            aria-label="scrollable auto tabs example"
                            onChange={onChangeTab}
                        >
                            <Tab
                                className="navTabs--item custom-tab"
                                label={tr('個人カスタマー管理')}
                                value={Constant.CORPORATION_CUSTOMER_TAB_MANAGEMENT.TAB_CUSTOMER_LIST_CORPORATION}
                                aria-selected="true"
                            />
                        </Tabs>
                    </AppBar>
                </div>
            </div>
            {renderContentTab(tabSelected)}
            <CancelTabsDialog argsAll={argsAll} />
        </div>
    );
}
